module.exports = __webpack_public_path__ + "static/media/icoLockPad.4b6b8fee.svg";